import CreateSmallGroup from './container.js'
export default CreateSmallGroup
